import { module } from 'angular';

import { default as knowledgeBaseServiceName, KnowledgeBaseService } from './knowledge-base.service';

export default module('contact.agent.core.knowledgeBase', []).service(knowledgeBaseServiceName, KnowledgeBaseService).name;
